export const CHANGE_SKIP = 'CHANGE_SKIP';
export const CHANGE_LIST_ITEM_LOADING = 'CHANGE_LIST_ITEM_LOADING';
export const CHANGE_LIST_LOADING = 'CHANGE_LIST_LOADING';
export const SET_ITEM = 'SET_ITEM';
export const SET_LIST = 'SET_LIST';
export const SET_LIST_LENGTH = 'SET_LIST_LENGTH';

export const STREAMS_CHANGE_SKIP = 'STREAMS_CHANGE_SKIP';
export const STREAMS_ITEM_REQUEST_STATUS = 'STREAMS_ITEM_REQUEST_STATUS';
export const STREAMS_REQUEST_STATUS = 'STREAMS_REQUEST_STATUS';
export const STREAMS_SET_ITEM = 'STREAMS_SET_ITEM';
export const STREAMS_SET_LIST = 'STREAMS_SET_LIST';
export const STREAMS_SET_LIST_LENGTH = 'STREAMS_SET_LIST_LENGTH';
